/**
 * Instance Advice API — one page of advice, and the download counter.
 *
 * Both are mutations, not queries: the advice must be fetched fresh every
 * time the user asks (open, Regenerate, next page) — legacy never served it
 * from a cache — and the counter is a fire-and-forget POST.
 *
 * `getAdvice` takes the request built by ../costAdviceRequest.js adviceRequest
 * (`{ kind, body | params }`); read the reply with readAdvice.
 */
import { API_ENDPOINTS } from '@services/apiEndpoints';
import { baseApi } from '@services/baseApi';

const { COST_ADVICE, SCALER_COST_ADVICE, LATEST_RECOMMENDATIONS, DOWNLOAD_COUNT } =
  API_ENDPOINTS.COST_ADVICE;

export const costAdviceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdvice: builder.mutation({
      query: ({ kind, body, params }) =>
        kind === 'large'
          ? { url: LATEST_RECOMMENDATIONS, params }
          : { url: kind === 'scaler' ? SCALER_COST_ADVICE : COST_ADVICE, method: 'POST', body },
    }),
    /** Legacy: POST /download-count?portfolio_id=&app_name=EIA|CCA, no body. */
    countDownload: builder.mutation({
      query: ({ portfolioId, appName }) => ({
        url: DOWNLOAD_COUNT,
        method: 'POST',
        params: { portfolio_id: portfolioId, app_name: appName },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAdviceMutation, useCountDownloadMutation } = costAdviceApi;
